import { Alert, AlertTitle } from "@mui/material";
import { DroppedCampaign } from "../common/types";

interface PartialReportNoticeProps {
  dropped: Array<DroppedCampaign>;
}

function PartialReportNotice({ dropped }: PartialReportNoticeProps) {
  if (!dropped.length) return null;

  const named = dropped.filter(
    (campaign): campaign is DroppedCampaign & { name: string } =>
      Boolean(campaign.name)
  );
  const unnamed = dropped.length - named.length;
  const one = dropped.length === 1;

  return (
    <Alert severity="info" sx={{ marginBottom: "16px" }}>
      <AlertTitle>
        {one
          ? "One campaign is not displayed"
          : `${dropped.length} campaigns are not displayed`}
      </AlertTitle>
      The totals and chart above include {one ? "this campaign" : "these campaigns"};
      only {one ? "its" : "their"} individual breakdown is missing.
      {named.length > 0 && (
        <ul style={{ margin: "8px 0 0", paddingInlineStart: "20px" }}>
          {named.map((campaign) => (
            <li key={campaign.id || campaign.name}>{campaign.name}</li>
          ))}
        </ul>
      )}
      {unnamed > 0 && (
        <div style={{ marginTop: "8px" }}>
          {unnamed === 1
            ? "One more could not be identified."
            : `${unnamed} more could not be identified.`}
        </div>
      )}
    </Alert>
  );
}

export default PartialReportNotice;
